enum ErrorMessageMsg {
  InvalidEmail = "Please enter a valid email address",
  InvalidInputs = "Please make sure all inputs are valid",
  InvalidUsername = "Please enter a valid username",
  UnexpectedError = "An unexpected error occurred",
}

export default ErrorMessageMsg;
